<template>
    <div class="box">
        <img class="bg-img" src="../../assets/images/coupon/coupon_share@2x.png">
        <div class="footer">
            <van-button type="primary" class="btn" @click.stop="clickBack">返  回</van-button>
        </div>
    </div>
</template>
<script>
import { WeixinShare } from '@/utils/wx'
import Navbar from '@/components/Navbar'
import { queryUserById } from '@/api/home'

export default {
name:'CouponShare',
  data() {
    return {
      
    }
  },
  components: { Navbar },
  computed: {},
 
  mounted() {
      this.getUser()
  },
  watch: {},
  methods: {
   async getUser(){
      try {
      let res = await queryUserById()
      this.userInfo = res.result || {}
      setTimeout(function(){ WeixinShare.create(res.result)},200)
      } catch {}
    },
    clickBack() {
        var u = navigator.userAgent
        if (u.indexOf('miniProgram') !== -1) {
            // 在微信小程序
            window.wx.miniProgram.navigateBack()
        } else {
            // 在微信网页
            this.$router.go(-1)
        }
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
    width: 100%;
    height: 100vh;
    position: relative;
}
    
.bg-img {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
}

.footer{
    position: absolute;bottom:1.5rem;left:0;width: 100%;height:40px;text-align: center;z-index:10;
}
.btn{
    width: 148px;height: 40px !important;line-height: 40px;background: #1A8AF1;border-radius: 20px; color: #fff;font-size: 14px;margin: 0 auto;
    font-size: 16px;
}
</style>
